module.exports = __webpack_public_path__ + "img/notionPage.ca727cf1.jpg";